<div class="loading-overlay">
  <div class="content" *ngIf="isShown && !errorMessage">
    <app-ui-icon-x
      class="animate-spin"
      [iconName]="IconName.ProgressBar"
      [size]="32"
      [color]="'#014FCF'"
    ></app-ui-icon-x>
    <app-logo></app-logo>
  </div>

  <div class="content" *ngIf="isShown && errorMessage">
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 2H8L2 8V16L8 22H16L22 16V8L16 2Z"
        stroke="#000000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 8V12"
        stroke="#000000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 16.0195V16"
        stroke="#000000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <div class="error">
      <span class="body-1-semi-bold"> {{ errorMessage }}</span>
      <app-x-button (click)="goBack()" [style]="'outlined'"> {{ 'go_back' | translate }} </app-x-button>
    </div>
  </div>
</div>
